module.exports = __webpack_public_path__ + "static/img/1.ffc15b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/eng/1.png
// module id = GCbP
// module chunks = 0